import axios from "@/plugins/axios";

export default {
  getSupplierBookingAndContacts(supplier_id, query) {
    return axios.get(`/suppliers/${supplier_id}/bookings`, { params: { query } });
  },
};
